import { compose, withStateHandlers } from 'recompose';
import styles from './styles.module.scss';
import { addProps } from 'utils/recompose';

const tooltipStyle = ({ position = 'right' }) => {
  const style = {
    right: styles.helper_right,
    left: styles.helper_left,
  };
  return `${styles.helper} ${style[position]}`;
};

const handleMouseOver = ({ isClicked, onMouseEnter }) => () => {
  onMouseEnter && onMouseEnter();
  if (!isClicked) return { isOpen: true };
};

const handleClick = (
  { isOpen, onClick, isClicked },
  { preventClick },
) => () => {
  if (preventClick) return;
  onClick && onClick();
  if (!isClicked) return { isClicked: true, isOpen: true };
  return { isClicked: !isClicked, isOpen: !isOpen };
};

const handleMouseLeave = ({ isClicked, onMouseLeave }) => () => {
  onMouseLeave && onMouseLeave();
  if (!isClicked) return { isOpen: false };
};

export default compose(
  withStateHandlers(
    { isOpen: false, isClicked: false },
    {
      handleMouseOver,
      handleMouseLeave,
      handleClick,
    },
  ),
  addProps({ tooltipStyle }),
);
